import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import { AskGusComponent } from '../components/ask-gus/ask-gus-component';

import Layout from '../components/Layout';
import Features from '../components/Features';
import { Offer } from '../components/offer';
import { PreviewCompatibleImage } from '../components/PreviewCompatibleImage';
import { SignUpComponent } from '../components/sign-up/sign-up-component';

export const IndexPageTemplate = ({ image, title, subheading, intro }) => (
  <div>
    <div
      className="full-width-image margin-top-0"
      style={{
        backgroundImage: `url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })`,
        backgroundPosition: `center center`,
        backgroundAttachment: `fixed`,
      }}
    >
      <div
        style={{
          display: 'flex',
          height: '150px',
          lineHeight: '1',
          justifyContent: 'space-around',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <h1
          className="has-text-weight-bold is-size-3-mobile is-size-2-tablet is-size-1-widescreen"
          style={{
            color: 'white',
            lineHeight: '1',
            padding: '0.25em',
          }}
        >
          {title}
        </h1>
        <h3
          className="has-text-weight-bold is-size-5-mobile is-size-5-tablet is-size-4-widescreen"
          style={{
            color: 'white',
            lineHeight: '1',
            padding: '0.25em',
          }}
        >
          {subheading}
        </h3>
      </div>
    </div>
    <section className="section section--gradient">
      <div className="columns">
        <div className="column is-10 is-offset-1">
          <div className="content">
            <Features gridItems={intro.blurbs} />
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column">
          {intro.offer ? (
            <Offer
              title={intro.offer.title}
              headline={intro.offer.headline}
              description={intro.offer.description}
              image={intro.offer.image}
              newOptions={intro.offer.newOptions}
              usedOptions={intro.offer.usedOptions}
              gleenOptions={intro.offer.gleenOptions}
            />
          ) : (
            ''
          )}
        </div>
        <div className="column">
          <div className="box">
            <div className="is-size-2 has-text-centered">Ask Gus</div>
            <div className="is-size-6 mb-20">
              Appliance issues? Post your problem and email address below. Our
              team of experts will get back to you with answers.
            </div>
            <div className="columns">
              <div className="column is-4">
                <PreviewCompatibleImage
                  imageInfo={{
                    image: '/img/gus.jpg',
                    alt: `Gus`,
                  }}
                />
              </div>
              <div className="column is-8">
                <AskGusComponent />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="columns">
        <div className="column is-one-quarter-tablet is-one-third-desktop" />
        <div className="column">
          <SignUpComponent />
        </div>
        <div className="column is-one-quarter-tablet is-one-third-desktop" />
      </div>
    </section>
  </div>
);

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  subheading: PropTypes.string,
  mainpitch: PropTypes.object,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
    offer: PropTypes.shape({
      title: PropTypes.string,
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    }),
  }),
};

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Layout>
      <IndexPageTemplate
        image={frontmatter.image}
        title={frontmatter.title}
        subheading={frontmatter.subheading}
        mainpitch={frontmatter.mainpitch}
        intro={frontmatter.intro}
      />
    </Layout>
  );
};

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
};

export default IndexPage;

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        title
        image {
          childImageSharp {
            fluid(maxWidth: 4096, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        subheading
        intro {
          blurbs {
            image {
              childImageSharp {
                fixed(width: 56, quality: 64) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
            text
            tag
          }
          offer {
            title
            headline
            description
            image {
              childImageSharp {
                fluid(maxWidth: 512, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            newOptions {
              image {
                childImageSharp {
                  fluid(maxWidth: 512, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              price
              url
            }
            usedOptions {
              image {
                childImageSharp {
                  fluid(maxWidth: 512, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              price
              url
            }
            gleenOptions {
              image {
                childImageSharp {
                  fluid(maxWidth: 512, quality: 100) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
              price
              url
            }
          }
        }
      }
    }
  }
`;
